import { DefineDevice, VirtualMer68Max, VirtualMer68SE_JT, VK } from '@hid/define/define'

const createFnStandardKeyMap = (entries: Array<[number, VK]>) => new Map<number, VK>(entries)

// Jingtai V2 keyboard docs expose a stable vendor keycode table for the
// common FN multimedia/browser/system actions. Use that vendor-wide map as the
// default decode path, then layer on per-device overrides only where firmware
// truly diverges.
const jingtaiV2VendorFnStandardKeyMap = createFnStandardKeyMap([
  [0x1808, 0xb6 as VK], // WFIL -> 资源管理器
  [0x2183, 0xb5 as VK], // Music -> 媒体播放器
  [0x218a, 0xb4 as VK], // Mail
  [0x2192, 0xb7 as VK], // Calculator
  [0x2194, 0xb6 as VK], // My Computer -> 资源管理器
  [0x20b5, 0xb0 as VK], // Next track
  [0x20b6, 0xb1 as VK], // Previous track
  [0x20b7, 0xb2 as VK], // Stop
  [0x20cd, 0xb3 as VK], // Play/Pause
  [0x20e2, 0xad as VK], // Mute
  [0x20e9, 0xaf as VK], // Volume up
  [0x20ea, 0xae as VK], // Volume down
  [0x2221, 0xaa as VK], // Browser search
  [0x2223, 0xac as VK], // Browser home
  [0x2224, 0xa6 as VK], // Browser back
  [0x2225, 0xa7 as VK], // Browser forward
  [0x2226, 0xa9 as VK], // Browser stop
  [0x2227, 0xa8 as VK], // Browser refresh
])

const jingtaiV2FnStandardKeyOverridesByDevice = new Map<DefineDevice, ReadonlyMap<number, VK>>([
  [
    VirtualMer68Max,
    createFnStandardKeyMap([
      [0xf310, 0xad as VK], // 旧固件把装饰灯模式键复用为静音
    ]),
  ],
  [
    VirtualMer68SE_JT,
    createFnStandardKeyMap([
      [0xf310, 0xad as VK], // 旧固件把装饰灯模式键复用为静音
    ]),
  ],
])

export const getJingtaiV2FnStandardKeyMap = (deviceID: DefineDevice): ReadonlyMap<number, VK> => {
  const map = new Map<number, VK>(jingtaiV2VendorFnStandardKeyMap)
  const overrides = jingtaiV2FnStandardKeyOverridesByDevice.get(deviceID)

  overrides?.forEach((vk, rawCode) => {
    map.set(rawCode, vk)
  })

  return map
}
